module.exports = __webpack_public_path__ + "static/media/file-plus-circle.c856e19d.svg";